import React from 'react';
import Layout from "../../components/layout/Layout";
import UserManagement from "../../components/users/UserManagement";
const ManageUsersPage = () => {
    return (
      <Layout>
        <main className="admin-background">
          <UserManagement /></main>
      </Layout>
    );
  }

  export default (ManageUsersPage);